export default __webpack_public_path__ + "static/media/161-ivory-coast.c1b7c85e.svg";